import { SHEET_DEFECTS } from './workbook.types';

export const WIZARD_STEPS = {
  CHOOSE_FILE: 'CHOOSE_FILE',
  SELECT_TABS: 'SELECT_TABS',
  ANALYZING: 'ANALYZING',
  REVIEW: 'REVIEW',
  UPLOADING: 'UPLOADING',
} as const;

export const TAB_STATUSES = {
  CLEAN: 'CLEAN',
  PARTIAL: 'PARTIAL',
  EXCLUDED: 'EXCLUDED',
} as const;

export const RESULT_VARIANTS = {
  SUCCESS: 'SUCCESS',
  PARTIAL: 'PARTIAL',
} as const;

// Every structural defect the parser can report is a reason a tab shows up
// excluded, plus the one case only the analysis can know about.
export const TAB_EXCLUSION_REASONS = {
  ...SHEET_DEFECTS,
  NOTHING_TO_IMPORT: 'NOTHING_TO_IMPORT',
} as const;

export const ISSUE_REASONS = {
  USER_NOT_FOUND: 'USER_NOT_FOUND',
  INVALID_ATTENDEE: 'INVALID_ATTENDEE',
} as const;

export type WizardStep = (typeof WIZARD_STEPS)[keyof typeof WIZARD_STEPS];
export type TabStatus = (typeof TAB_STATUSES)[keyof typeof TAB_STATUSES];
export type ResultVariant = (typeof RESULT_VARIANTS)[keyof typeof RESULT_VARIANTS];
export type TabExclusionReason = (typeof TAB_EXCLUSION_REASONS)[keyof typeof TAB_EXCLUSION_REASONS];
export type IssueReason = (typeof ISSUE_REASONS)[keyof typeof ISSUE_REASONS];

export type SheetIssue = {
  sheetName: string;
  shiftTitle: string;
  date: string;
  reason: IssueReason;
  reasonContext?: { value?: string };
};

type TabAnalysisBase = {
  sheetName: string;
  importedCount: number;
  skippedCount: number;
  issues: SheetIssue[];
};

// A union rather than an optional field, so an excluded tab cannot exist without
// a reason and consumers never need a non-null assertion to read one.
export type TabAnalysis =
  | (TabAnalysisBase & {
      status: typeof TAB_STATUSES.CLEAN | typeof TAB_STATUSES.PARTIAL;
    })
  | (TabAnalysisBase & {
      status: typeof TAB_STATUSES.EXCLUDED;
      exclusionReason: TabExclusionReason;
    });

// POST /v1/schedules, after the api-client strips the { success, data } envelope.
export type ImportScheduleResponse = {
  scheduleEventGroupsCreated: number;
  scheduleEventGroupsReused: number;
  scheduleEventsCreated: number;
  scheduleEventsSkipped: number;
  attendeesUnresolved: number;
  eventsDeleted: number;
  usersCreated: number;
  usersCreationFailed: number;
};

export type ImportResult = {
  id: string;
  fileName: string;
  completedAt: number;
  importedCount: number;
  skippedCount: number;
  eventsDeleted: number;
  tabsImported: number;
  tabsTotal: number;
  tabsSkipped: number;
  issues: SheetIssue[];
};

export type LastUpload = {
  fileName: string;
  uploadedAt: number;
};

